import { Component, Input } from '@angular/core';
import { IconDynamicColors } from '../../interfaces/colors';
import { IconDynamicData } from '../../interfaces/data';

@Component({
  selector: 'cigna-icon-collapsible-chat-bubble',
  templateUrl: './chat-collapsible.component.html',
})
export class IconCollapsibleChatBubbleComponent {
  @Input() public hasShellMinimized: boolean;
  @Input() public shouldExpand: boolean;
  @Input()
  public canShellOpenOrMinimized: boolean;
  @Input()
  public data: IconDynamicData;
  @Input()
  public set colors(payload: IconDynamicColors) {
    if (payload.color) {
      this.backgroundColor = payload.color;
    }

    if (payload.textColor) {
      this.textColor = payload.textColor;
    }

    if (payload.strokeColor) {
      this.strokeColor = payload.strokeColor;
    }

    if (payload.dropShadow) {
      this.dropShadow = payload.dropShadow;
    }
  }

  public backgroundColor = '#118503';
  public textColor = '#FFFFFF';
  public strokeColor = '';
  public dropShadow = '';
  @Input() public isLiveChatAvailability: boolean;
}
